import {
  messengerGet,
  messengerPost,
  messengerPut,
  messengerDel,
  Pagination,
  Success,
} from './methods';

export interface Duvida {
  flgEmResposta: boolean;
  ldapResposta?: string;
  dataDuvida: string;
  duvida: string;
  idDuvidaFrequente: number;
  dataResposta?: string;
  flgPublica?: boolean;
  resposta?: string;
  usuarioResposta?: string;
}

export interface Conversa {
  cpfUsuario: string;
  duvidas: Array<Duvida>;
  nome: string;
  flgDestaque: boolean;
  flgEmResposta: boolean;
}

export type Conversas = Array<Conversa>;

export interface PaginationDuvidas extends Pagination<Conversas> {
  countMensagensPendentes: number;
  countMensagensRespondidas: number;
  countMensagensEmResposta: number;
}

export interface MensagensFiltros extends Record<string, any> {
  nomeAssociadoOrCpf?: string;
  page?: number;
  respondido?: boolean;
  emResposta?: boolean;
  size?: number;
}

interface Resposta {
  idDuvida: number;
  resposta: string;
  flgPublica: boolean;
}

interface AlteraStatus {
  flgPublica: boolean;
  idDuvida: number;
}

interface EmRespostaStatus {
  flgEmResposta: boolean;
  idDuvida: number;
}

interface MensagemRequest {
  duvida: string;
  idEvento: number;
}

interface EditarMensagemRequest {
  duvida: any;
  idDuvida: any;
  flgPublica: boolean;
}

interface MensagemResponse {
  dataDuvida: string;
  dataResposta: string;
  duvida: string;
  idDuvidaFrequente: number;
  lido: boolean;
  resposta: string;
  usuarioDuvida: string;
}

const duvidas = {
  listar: (idEvento: number, filtros?: MensagensFiltros) => {
    const endpoint = 'duvida/duvida-evento';
    return messengerGet<PaginationDuvidas>(endpoint, {
      params: { ...filtros, idEvento },
    });
  },
  excluirResposta: (oidDuvida: number) => {
    return messengerDel(`duvida/registra-resposta?oidDuvida=${oidDuvida}`);
  },
  mensagem: (data: MensagemRequest) => {
    const endpoint = 'duvida/registra-duvida';
    return messengerPost<MensagemResponse>(endpoint, data);
  },
  editarMensagem: (data: EditarMensagemRequest) => {
    const endpoint = 'duvida/registra-duvida';
    return messengerPut<Success>(endpoint, data);
  },
  responder: (data: Resposta) => {
    const endpoint = 'duvida/registra-resposta';
    return messengerPost<Duvida>(endpoint, data);
  },
  alterarStatus: (data: AlteraStatus) => {
    const endpoint = 'duvida/status';
    return messengerPut<Success>(endpoint, data);
  },
  alterarEmResposta: (data: EmRespostaStatus) => {
    const endpoint = 'duvida/mensagem-em-resposta';
    return messengerPut<Success>(endpoint, data);
  },
};

export default duvidas;
